export default {"src":"/_next/static/media/steam.b53a2af8.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};